import React, { useState, useEffect } from 'react';
import * as ui from '@digital/ui';
import { Collapse, Icon } from 'antd';

import {
  CrfContratadoOverHeadAnual,
  CrfContratadoRequisicaoCompraMaterial,
  CrfContratadoRequisicaoCompraServico,
  getAllCrfContratadoMaterialByContaContabilCc,
  getAllCrfContratadoServicoByContaContabilCc,
  getAllCrfContratadoTipoOverHeadByContaContabilCc,
  getAllResumoCrfContratadoProjeto,
  ResumoCrfContratado
} from '@app/api/crf/crfContrato';

import FormTableContratadoRequisicaoCompraMaterial from './FormTableContratadoRequisicaoCompraMaterial';
import FormTableContratadoRequisicaoCompraServico from './FormTableContratadoRequisicaoCompraServico';
import FormTableContratadoOverheadAnual from './FormTableContratadoOverheadAnual';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';

interface FormResumoContratadoProps {
  projetoId: string,
}

const { Panel } = Collapse;

const FormTableResumoContratado = ({ projetoId }: FormResumoContratadoProps) => {

  const [resumoContratado, setResumoContratado] = useState<ResumoCrfContratado[]>();
  const [contratadoMaterial, setContratadoMaterial] = useState<CrfContratadoRequisicaoCompraMaterial[]>();
  const [contratadoServico, setContratadoServico] = useState<CrfContratadoRequisicaoCompraServico[]>();
  const [valorTotal, setValorTotal] = useState<string>();
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [contaContabilCcId, setContaContabilCcId] = useState<string>();
  const [displayWidgetContratado, setDisplayWidgetContratado] = useState({ display: 'none' });
  const [contratadoOverHeadAnual, setContratadoOverHeadAnual] = useState<CrfContratadoOverHeadAnual>();

  const handleTabelaContratadoMaterial = (result: CrfContratadoRequisicaoCompraMaterial[]) => {
    setContratadoMaterial([]);
    if (result && result.length > 0) {
      setContratadoMaterial(result);
      setDisplayWidgetContratado({ display: 'block' });
    } else {
      setContratadoMaterial([]);
    }
  };

  const handleTabelaContratadoServico = (result: CrfContratadoRequisicaoCompraServico[]) => {
    setContratadoServico([]);
    if (result && result.length > 0) {
      setContratadoServico(result);
      setDisplayWidgetContratado({ display: 'block' });
    } else {
      setContratadoServico([]);
    }
  };

  const handleTabelaContratadoTipoOverHead = (result: any) => {
    setContratadoOverHeadAnual({} as CrfContratadoOverHeadAnual);
    if (result) {
      setContratadoOverHeadAnual(result);
      setDisplayWidgetContratado({ display: 'block' });
    } else {
    }
  };

  const getResumoContratado = async (projetoId: string) => {
    setContratadoMaterial([]);
    setContratadoServico([]);
    const result = await getAllResumoCrfContratadoProjeto(projetoId);
    if (result) {
      setResumoContratado(result);
    }
  };

  useEffect(() => {
    if (resumoContratado && resumoContratado.length > 0) {
      var requisitado = resumoContratado[resumoContratado.length - 1];
      if (requisitado) {
        setValorTotal(requisitado.valorTotalFormatado);
      }
    }
  }, [resumoContratado]);

  useEffect(() => {
    getResumoContratado(projetoId);
    setDisplayWidgetContratado({ display: 'none' });
  }, [])

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      var obj = selectedRows[0];
      if (selectedRows) {
        setContaContabilCcId(obj.crfContaContabilCcId);
        setResultadoSelecionado(selectedRowKeys);
      } else {
        setResultadoSelecionado('');
      }
    },
    getCheckboxProps: (record: { name: any }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: resultadoSelecionado,
    type: 'radio',
  };

  const getContratadoMaterial = async (ccId: string) => {
    const result = await getAllCrfContratadoMaterialByContaContabilCc(ccId);
    if (result) {
      handleTabelaContratadoMaterial(result);
    }
  };

  const getContratadoServico = async (ccId: string) => {
    const result = await getAllCrfContratadoServicoByContaContabilCc(ccId);
    if (result) {
      handleTabelaContratadoServico(result);
    }
  };

  const getContratadoTipoOverHead = async (id: string) => {
    const result = await getAllCrfContratadoTipoOverHeadByContaContabilCc(id);
    if (result) {
      handleTabelaContratadoTipoOverHead(result);
    }
  };

  const verContratado = () => {
    if (contaContabilCcId) {
      getContratadoMaterial(contaContabilCcId);
      getContratadoServico(contaContabilCcId);
      getContratadoTipoOverHead(contaContabilCcId);
    } else {
      ui.notification.error('Você deve selecionar um item');
    }
  };

  const atualizaContratadoTipoOverHead = (id: any) => {
    const getContratadoOverhead = async (id: string) => {
      const result = await getAllCrfContratadoTipoOverHeadByContaContabilCc(id);
      if (result) {
        setContratadoOverHeadAnual(result);
      }
    };

    if (id) {
      getContratadoOverhead(id);
    }
    if (projetoId) {
      getResumoContratado(projetoId);
    }
  };

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Conta Contábil',
        dataIndex: 'codigoContaContabil',
        width: '2%',
        ...mountFormFilterDropDown("contaContabilCodigo", "Buscar por conta contábil"),
      },
      {
        title: 'Código do Agrupador',
        dataIndex: 'codigoAgrupador',
        width: '13%',
        ...mountFormFilterDropDown("codigoAgrupador", "Buscar por código do agrupador"),
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '35%',
        ...mountFormFilterDropDown("nome", "Buscar por nome"),
      },
      {
        title: 'Overhead total',
        dataIndex: 'valorTotalTipoOverHeadFormatado',
        width: '35%',
      },
      {
        title: 'Status Contratado',
        dataIndex: 'status',
        width: '35%',
      },
      {
        title: 'Valor Contratado',
        dataIndex: 'valorTotalCurrency',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'contratoCompraValorTotalFormatado',
            width: '1%',
          },
        ],
      },
    ] as ui.InlineEditColumnProps<ResumoCrfContratado>[];
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Resumo Contratado" style={{ border: 0 }}>
          <ui.MasterDetailForm>
            <ui.Widget
              actions={[
                resumoContratado && resumoContratado.length > 0 && (
                  <ui.Button
                    type="primary"
                    title="VER CONTRATADO"
                    icon="data-database"
                    onClick={() => {
                      verContratado();
                    }}
                  />
                ),
              ]}>
              <ui.Row>
                <ui.Table
                  rowKey="index"
                  columns={customColumns()}
                  dataSource={resumoContratado || []}
                  rowSelection={{
                    ...rowSelection,
                  }}
                  pagination={
                    {
                      pageSize: 5,
                    }
                  }
                />
              </ui.Row>
            </ui.Widget>
          </ui.MasterDetailForm>
        </Panel>
      </Collapse>


      <FormTableContratadoRequisicaoCompraMaterial
        contratadoRequisicaoCompraMaterial={contratadoMaterial || []}
        style={displayWidgetContratado}
      />

      <FormTableContratadoRequisicaoCompraServico
        contratadoRequisicaoCompraServico={contratadoServico || []}
        style={displayWidgetContratado}
      />

      <FormTableContratadoOverheadAnual
        contratadoOverHeadAnual={contratadoOverHeadAnual || ({} as CrfContratadoOverHeadAnual)}
        style={displayWidgetContratado}
        atualizaContratadoTipoOverHead={atualizaContratadoTipoOverHead}
        updateContratadoOverHeadAnual={(crfContaContabilCcId) => {
          getContratadoTipoOverHead(crfContaContabilCcId);
        }}
      />
    </>

  );
};

export default FormTableResumoContratado;
